import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayFindsPeriod({
  setFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="findsPeriod"
      filters={filters}
      formHint="For example, period example 1, period example 2, period example 3"
      id="finds-period"
      label="Period"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HeritageGatewayFindsPeriod);
